
  // Get all "Read Bio" links
  let readBioLinks = document.querySelectorAll('.instructor--bio-link');

  let scrollTop = 0;
  let bodyPositionSetting = '';
  let htmlPositionSetting = '';
  let body = document.body;
  let html = document.documentElement;


  // Add click event listeners to each "Read Bio" link
  readBioLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent the default behavior of the anchor element

      togglePointerEventsOnLinks(true);

    bodyPositionSetting = body.style.position;
    htmlPositionSetting = html.style.position;

    // scrollTop = 100;
    body.style.position = 'relative';
    body.style.overflowY = 'hidden';
    html.style.position = 'relative';
    html.style.overflowY = 'hidden';

      // Get the modal ID from the data-modal attribute
      let modalId = link.getAttribute('data-modal');
      let cleanModalId = modalId.substring(1); // Remove the pound sign from the modal ID

      // Get the corresponding modal element
      let modal = document.getElementById(cleanModalId);

      // Remove the 'display: none' style from the modal
      modal.style.display = 'block';

      // Get the close button inside the modal
      let closeButton = modal.querySelector('.modal__close');

      // Add click event listener to the close button
      closeButton.addEventListener('click', function () {
        // Hide the modal by adding 'display: none' style
          closeModal(modal);
      });

      // Add event listener to the document for the Escape key
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          // Hide the modal by adding 'display: none' style
          closeModal(modal);
        }
      });
    });
  });

  closeModal = (modal) => {
    modal.style.display = 'none';
    body.style.overflowY = 'initial';
    html.style.overflowY = 'initial';
    body.style.position = bodyPositionSetting;
    html.style.position = htmlPositionSetting;
    togglePointerEventsOnLinks(false);
    // html.classList.remove('isFixed');
  }

  togglePointerEventsOnLinks = (disable) => {
    readBioLinks.forEach(link => {
        link.style.pointerEvents = disable ? 'none' : '';
      });
    }

  // Add click event listeners to category switcher buttons
  //categories.forEach(function (category) {
    document.querySelectorAll('.switcher-button').forEach(function (switcherButton) {
    if (switcherButton) {
      switcherButton.addEventListener('click', function () {
        // Remove 'active' class from all switcher buttons and instructors
        document.querySelectorAll('.switcher-button').forEach(function (button) {
          button.classList.remove('active');
        });
        document.querySelectorAll('.instructor').forEach(function (instructor) {
          instructor.classList.remove('active');
        });
        
        // Add 'active' class to the selected switcher button and corresponding instructor category
        switcherButton.classList.add('active');
        document.querySelectorAll('.instructor-category-' + switcherButton.getAttribute('id').replace('switcher-','')).forEach(function (instructor) {
          instructor.classList.add('active');
        });
      });
    }
   });

  // Set the initial category on document ready
  document.addEventListener('DOMContentLoaded', function () {
    let firstCategory = document.getElementById('instructors-section').getAttribute('data-firstcategory');

    // Remove 'active' class from all switcher buttons and instructors
    document.querySelectorAll('.switcher-button').forEach(function (button) {
      button.classList.remove('active');
    });
    document.querySelectorAll('.instructor').forEach(function (instructor) {
      instructor.classList.remove('active');
    });

    // Add 'active' class to the first category switcher button and corresponding instructor category
    document.getElementById('switcher-' + firstCategory).classList.add('active');
    document.querySelectorAll('.instructor-category-' + firstCategory).forEach(function (instructor) {
      instructor.classList.add('active');
    });
  });
